import React, { useState, useEffect } from 'react';
import { LANGUAGES } from '../constants';

const TextEditor = ({ data, onUpdate, parameterName, title = "Basic Text Content", activeLang, onLangChange }) => {
    // activeLang via props

    // Local state for immediate typing feedback
    const [localValue, setLocalValue] = useState(data?.[activeLang] || '');

    useEffect(() => {
        setLocalValue(data?.[activeLang] || '');
    }, [activeLang, data]);

    const handleChange = (e) => {
        const newValue = e.target.value;
        setLocalValue(newValue);

        // Propagate change up
        onUpdate({
            ...data,
            [activeLang]: newValue
        });
    };

    const activeLangObj = LANGUAGES.find(l => l.code === activeLang);
    const textareaId = `pcr-text-${parameterName}-${activeLang}`;

    return (
        <div>
            <h2 className="pcr-section-title">{title} - {parameterName}</h2>

            <div className="pcr-lang-tabs" role="tablist" aria-label="Language selection">
                {LANGUAGES.map((lang, idx) => (
                    <button
                        key={lang.code}
                        id={`tab-${lang.code}`}
                        type="button"
                        role="tab"
                        aria-selected={activeLang === lang.code}
                        aria-controls={`panel-${lang.code}`}
                        tabIndex={activeLang === lang.code ? 0 : -1}
                        className={`pcr-lang-tab ${activeLang === lang.code ? 'active' : ''}`}
                        onClick={() => onLangChange(lang.code)}
                        onKeyDown={(e) => {
                            let newIndex = -1;
                            if (e.key === 'ArrowRight') {
                                newIndex = (idx + 1) % LANGUAGES.length;
                            } else if (e.key === 'ArrowLeft') {
                                newIndex = (idx - 1 + LANGUAGES.length) % LANGUAGES.length;
                            }

                            if (newIndex !== -1) {
                                e.preventDefault();
                                onLangChange(LANGUAGES[newIndex].code);
                                // Focus management relies on the newly rendered button having tabIndex=0 
                                // and the user's focus remaining in the container or shifting naturally.
                                // React's declarative nature handles the state update.
                            }
                        }}
                    >
                        {lang.label}
                    </button>
                ))}
            </div>

            <div
                className="pcr-editor-container"
                role="tabpanel"
                id={`panel-${activeLang}`}
                aria-labelledby={`tab-${activeLang}`}
            >
                <label className="pcr-editor-label" htmlFor={textareaId}>
                    Content for {activeLangObj?.label}
                </label>
                <textarea
                    id={textareaId}
                    className="pcr-textarea"
                    value={localValue}
                    onChange={handleChange}
                    placeholder={`Enter ${activeLangObj?.label} content for ${parameterName}...`}
                />
                <div className="pcr-word-count">
                    {localValue.length} characters
                </div>
            </div>

            <div style={{ marginTop: '2rem', padding: '1rem', background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: '8px', fontSize: '0.9rem', color: '#92400e' }}>
                <strong>💡 Tip:</strong> Keep your descriptions concise (under 200 characters) for better readability on mobile reports.
            </div>
        </div>
    );
};

export default TextEditor;
